/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Cognito Challenge Parameters
 * @export
 * @interface CognitoChallengeParameters
 */
export interface CognitoChallengeParameters {
    /**
     * Code Delivery Medium
     * @type {string}
     * @memberof CognitoChallengeParameters
     */
    codeDeliveryMedium?: CognitoChallengeParametersCodeDeliveryMediumEnum;
    /**
     * Code Delivery Destination
     * @type {string}
     * @memberof CognitoChallengeParameters
     */
    codeDeliveryDestination?: string;
}


/**
 * @export
 */
export const CognitoChallengeParametersCodeDeliveryMediumEnum = {
    Sms: 'SMS'
} as const;
export type CognitoChallengeParametersCodeDeliveryMediumEnum = typeof CognitoChallengeParametersCodeDeliveryMediumEnum[keyof typeof CognitoChallengeParametersCodeDeliveryMediumEnum];


/**
 * Check if a given object implements the CognitoChallengeParameters interface.
 */
export function instanceOfCognitoChallengeParameters(value: object): value is CognitoChallengeParameters {
    return true;
}

export function CognitoChallengeParametersFromJSON(json: any): CognitoChallengeParameters {
    return CognitoChallengeParametersFromJSONTyped(json, false);
}

export function CognitoChallengeParametersFromJSONTyped(json: any, ignoreDiscriminator: boolean): CognitoChallengeParameters {
    if (json == null) {
        return json;
    }
    return {
        
        'codeDeliveryMedium': json['codeDeliveryMedium'] == null ? undefined : json['codeDeliveryMedium'],
        'codeDeliveryDestination': json['codeDeliveryDestination'] == null ? undefined : json['codeDeliveryDestination'],
    };
}

export function CognitoChallengeParametersToJSON(value?: CognitoChallengeParameters | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'codeDeliveryMedium': value['codeDeliveryMedium'],
        'codeDeliveryDestination': value['codeDeliveryDestination'],
    };
}

